'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initClientProfilerEvents = undefined;

var _constants = require('./constants');

/**
 * Setup client profile event listeners
 * @param {Function} beaconCall function to send the beacon data
 * @param {Function} loadBeaconCall function to call on load
 * @todo make this a default export
 */
var initClientProfilerEvents = exports.initClientProfilerEvents = function initClientProfilerEvents(beaconCall, loadBeaconCall) {
  var _window = window,
      addEventListener = _window.addEventListener;

  addEventListener('beforeunload', beaconCall, false);

  /**
   * We also want to beacon the data at the end of a profile
   * interval, so we listen for this custom event that's defined
   * in UserTiming.
   */
  addEventListener(_constants.DYNAMIC_EVENT_END_NAME, beaconCall);
  addEventListener('load', loadBeaconCall);
}; /* eslint-disable zillow/import/prefer-default-export */


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/initClientProfilerEvents.js
// module id = 495
// module chunks = 4